import Swiper, { Navigation, Pagination, A11y, Controller, EffectFade, EffectCards, EffectCreative } from 'swiper';

Swiper.use([Navigation, Pagination, A11y, Controller, EffectFade, EffectCards, EffectCreative]);

export default () => {
  const testiImage = new Swiper('.testimonials-image', {
    a11y: true,
    // loop: true,
    watchOverflow: true,
    // slidesPerView: 'auto',
    slideToClickedSlide: true,
    allowTouchMove: false,
    speed: 500, 
    effect: 'creative',
    rewind: true,
    creativeEffect: {
        limitProgress: 3,
        prev: {
          translate: [76, 0, 184],
          rotate: [0, 0, 0],
          opacity: 0,
        },
        next: {
            translate: [-76, 0, -184],
            rotate: [0, 0, 0],
        },
    },
    breakpoints: {
      320: {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
      },
      1200: {
        speed: 500, 
        effect: 'creative',
        creativeEffect: {
            limitProgress: 3,
            prev: {
              translate: [66, 0, 186],
              rotate: [0, 0, 0],
              opacity: 0,
            },
            next: {
                translate: [-66, 0, -186],
                rotate: [0, 0, 0],
            },
        },
      },
      1400: {
        speed: 500, 
        effect: 'creative',
        creativeEffect: {
            limitProgress: 3,
            prev: {
              translate: [76, 0, 184],
              rotate: [0, 0, 0],
              opacity: 0,
            },
            next: {
                translate: [-76, 0, -184],
                rotate: [0, 0, 0],
            },
        },
      },
    },
  });

  const testiContent = new Swiper('.testimonials-slider', {
    navigation: {
      nextEl: '.testimonials-swiper-wrapper .swiper-button-next',
      prevEl: '.testimonials-swiper-wrapper .swiper-button-prev',
    },
    // loop: true,
    rewind: true,
    a11y: true,
    keyboardControl: true,
    // grabCursor: true,
    watchOverflow: true,
    slidesPerView: 1,
    slideToClickedSlide: true,
    autoHeight: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 500,
    allowTouchMove: false,
  });

  testiImage.controller.control = testiContent;
	testiContent.controller.control = testiImage;
};